import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { LogoutComponent } from 'src/app/b2c-policy-core/logout/logout.component';
import { LandingPageComponent } from 'src/app/modules/fnol/landing-page/landing-page.component';
import { EstimateApprovalComponent } from 'src/app/modules/repair/estimate-approval/estimate-approval.component';
import { SupplierApprovalComponent } from 'src/app/modules/repair/supplier-approval/supplier-approval.component';
import { CustomerFeedback } from 'src/app/public/customer-feedback/customer-feedback.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { WidgetsModule } from 'src/app/widgets/widgets.module';

/**
 * Eager module for unauthenticated app-routing pages that use `component:` (no MsalGuard).
 * Declaring them only in lazy feature modules leaves pipes/directives (e.g. `translate`)
 * unavailable under Angular 21 when those modules are not loaded (NG0302).
 */
@NgModule({
  declarations: [
    SupplierApprovalComponent,
    EstimateApprovalComponent,
    CustomerFeedback,
    LogoutComponent,
    LandingPageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatProgressBarModule,
    TranslateModule,
    WidgetsModule,
    SharedModule
  ],
  exports: [
    SupplierApprovalComponent,
    EstimateApprovalComponent,
    CustomerFeedback,
    LogoutComponent,
    LandingPageComponent
  ]
})
export class PublicAccessModule {}
